var _rect, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#041742"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9419 9.59851L24.9412 9.60036L23.1421 12.3867C23.6925 13.4725 24.0046 14.6995 24.0046 16.0001C24.0046 20.4213 20.4206 24.0053 15.9994 24.0053C14.7005 24.0053 13.475 23.694 12.3903 23.1449L9.60303 24.9463C11.4057 26.2375 13.6129 27 15.9994 27C22.0746 27 26.9994 22.0752 26.9994 16.0001C26.9994 13.6113 26.2355 11.4022 24.9419 9.59851Z",
    fill: "url(#paint0_radial_539_154)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9995 21.5083C18.7076 21.5083 20.959 19.5594 21.4316 16.988C20.5745 16.8047 19.686 16.7061 18.7742 16.7061C16.0287 16.7061 13.4897 17.5836 11.4163 19.0695C12.4089 20.5407 14.0911 21.5083 15.9995 21.5083Z",
    fill: "url(#paint1_radial_539_154)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.723 15.7016C19.6846 15.7016 20.6213 15.8069 21.5247 16.0018C21.5247 16.0012 21.5247 16.0006 21.5247 15.9999C21.5247 12.9485 19.0511 10.475 15.9999 10.475C12.9486 10.475 10.475 12.9486 10.475 15.9999C10.475 16.2506 10.4936 16.4967 10.5261 16.7384C10.5256 16.7389 10.5251 16.7391 10.5245 16.7396C9.13318 17.7962 8.47343 18.6335 8.45248 18.6603C8.15799 17.8279 7.9947 16.9334 7.9947 15.9999C7.9947 11.5788 11.5787 7.99473 15.9999 7.99473C17.2945 7.99473 18.5162 8.30397 19.5983 8.84965L22.3872 7.04728C20.5862 5.75998 18.3825 5 15.9999 5C9.92481 5 5 9.92481 5 15.9999C5 18.4451 5.79909 20.7027 7.14899 22.5286C7.67043 21.5872 8.30341 20.7167 9.02999 19.9338C9.02999 19.9338 10.1149 18.8017 10.9463 18.2325C13.1291 16.6422 15.8155 15.7016 18.723 15.7016Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_539_154",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.9434 9.58537) scale(18.5065 18.5064)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0986,
    stopColor: "#26DB8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2628,
    stopColor: "#22D299"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5637,
    stopColor: "#19BABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886,
    stopColor: "#0E9DE5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_539_154",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.9435 9.58496) scale(18.5065 18.5064)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0986,
    stopColor: "#26DB8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2628,
    stopColor: "#22D299"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5637,
    stopColor: "#19BABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886,
    stopColor: "#0E9DE5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEon);
export default __webpack_public_path__ + "static/media/eon.138c64122f9c0d74557400ba72629a47.svg";
export { ForwardRef as ReactComponent };